module.exports = __webpack_public_path__ + "media/src/images/balloons/HomeBanner-laptop-6b8757c50a4955177caa5f6cec672395.png";